var media = [];
var variants = [];

function initialiseHeroCarousel() {
  var carouselContainer = $('.product-section__carousel');
  var thumbnail = $('.slider-nav > div');

  carouselContainer.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    speed: 200,
    fade: true,
     responsive: [
      {
        breakpoint: 992,
        settings: {
          dots: true
        }
      }
    ]
  });

  thumbnail.on('mouseenter', function() {
    $(this).trigger('click')
  })

  thumbnail.click(function() {
    carouselContainer.slick('slickGoTo', $(this).index());
  });

  carouselContainer.on('click', function() {
    carouselContainer.slick('slickNext');
  });

  carouselContainer.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    thumbnail.removeClass('focused');
    $(thumbnail.get(nextSlide)).addClass('focused');
  });
}

function initialiseDeliveryInfo() {
  var infoButton = $('.delivery-info__button');
  var closeButton = $(".delivery-info__card-close");
  var card = $('.delivery-info__card');

  infoButton.on('click', function handleToggleCard() {
    card.toggleClass('open');
    infoButton.toggleClass('active');
  });

  closeButton.on('click', function handleCloseCard() {
    card.removeClass('open');
    infoButton.removeClass('active');
  });
}

// ---------------------------------------------------------------------------
// Ajout au panier — ouverture du mini-panier SUR PLACE, sans quitter la page.
//
// POURQUOI. L'ancien code faisait window.location.assign('/cart') ~300 ms
// apres le fetch. Cette navigation detruit la page (et l'iframe sandbox du
// Web Pixel Shopify) avant que l'evenement product_added_to_cart soit envoye.
// Resultat : les Ajouts au panier remontes a Meta se sont effondres apres la
// refonte du 8 juillet (~37/j -> ~5/j), navigateur ET serveur, alors que les
// ventes reelles n'ont pas bouge. C'etait un probleme de mesure, pas de demande.
//
// LE FIX. On garde fetch('/cart/add.js') (c'est LUI qui emet l'evenement),
// puis on rafraichit le contenu du mini-panier sans recharger la page et on
// l'ouvre en place. La page survit -> le pixel a le temps de partir
// (navigateur + API Conversions, dedup via event_id gere par Shopify).
// On n'ajoute AUCUN fbq('track','AddToCart') manuel : ce serait un double
// comptage et casserait la deduplication.
//
// La .cart-popup est desktop-only en CSS d'origine ; l'affichage mobile
// (bottom sheet) + l'overlay + le bouton fermer sont ajoutes dans
// snippets/cart-popup.liquid. Les boutons quantite sont passes en delegation
// dans main.js pour survivre au remplacement du DOM ci-dessous.
// ---------------------------------------------------------------------------
function sonOpenCart() {
  $('.son-cart-overlay').addClass('on');
  $('.cart-popup').addClass('expanded');
  // Masque les elements flottants (barre d'achat collante, chat, WhatsApp)
  // pendant que le panier est ouvert : cf. CSS dans cart-popup.liquid.
  document.body.classList.add('son-cart-open');
  document.documentElement.style.overflow = 'hidden';
}

function sonCloseCart() {
  $('.son-cart-overlay').removeClass('on');
  $('.cart-popup').removeClass('expanded');
  document.body.classList.remove('son-cart-open');
  document.documentElement.style.overflow = '';
}

function sonBindCartClose() {
  // Delegation : survit au remplacement du .cart-popup.
  $(document)
    .off('click.sonCart')
    .on('click.sonCart', '.cart-popup__close-btn, .son-cart-overlay', function() {
      sonCloseCart();
    });
  $(document)
    .off('keydown.sonCart')
    .on('keydown.sonCart', function(e) {
      if (e.key === 'Escape') { sonCloseCart(); }
    });
}

function sonRefreshCartPopup() {
  // Re-fetch de la page courante (pas une navigation) pour recuperer le
  // .cart-popup rendu cote serveur avec le panier a jour, puis swap du DOM.
  return fetch(window.location.pathname + window.location.search, {
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
    credentials: 'same-origin'
  })
    .then(function(r) { return r.text(); })
    .then(function(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('.cart-popup');
      var current = document.querySelector('.cart-popup');
      if (fresh && current) {
        current.replaceWith(fresh);
      }
      // Met a jour le compteur du panier dans l'entete.
      var freshCount = doc.querySelector('.cart-count');
      if (freshCount) {
        $('.cart-count').text(freshCount.textContent);
      }
    });
}

function initialiseFormSubmit() {
  var form = $('#add-product-form');
  var submitting = false;

  sonBindCartClose();

  form.on('submit', function(event) {
    event.preventDefault();

    if (submitting) { return; }
    submitting = true;

    var buttons = form.find('button[name="add"]');
    buttons.prop('disabled', true);

    var data = {};
    $.each(form.serializeArray(), function(i, field) {
      data[field.name] = field.value;
    });

    var urlParams = new URLSearchParams(window.location.search);
    var variant = urlParams.get("variant");

    if (variant) {
      data.id = variant;
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(function(response) {
      if (!response.ok) {
        throw new Error('cart/add.js a répondu ' + response.status);
      }
      return response.json();
    })
    .then(function() {
      // On NE navigue PAS : la page reste vivante, le pixel part.
      return sonRefreshCartPopup();
    })
    .then(function() {
      sonOpenCart();
      submitting = false;
      buttons.prop('disabled', false);
    })
    .catch(function(error) {
      console.error('Ajout au panier impossible :', error);
      submitting = false;
      buttons.prop('disabled', false);
      var notice = form.find('[data-cart-error]');
      if (notice.length === 0) {
        notice = $('<div data-cart-error style="margin-top:12px;font-size:13px;color:#a32d2d"></div>');
        form.find('.ATC-Buttons').after(notice);
      }
      notice.text("L'ajout au panier a échoué. Réessayez, ou rechargez la page.");
    });
  });
}

// Conserve pour compatibilite : si une ancienne URL #open-cart arrive encore,
// on ouvre le panier (sans le refermer automatiquement, contrairement a avant).
function initialiseCartAutoExpand() {
  if (window.location.hash === '#open-cart') {
    sonOpenCart();
    window.history.replaceState({}, document.title, window.location.pathname);
  }
}

function main() {
  initialiseHeroCarousel();
  initialiseDeliveryInfo();
  initialiseFormSubmit();
  initialiseCartAutoExpand();

  function showIconText (elem) {
    $(elem).on('mouseover', function () {
      const v = ['handmade', 'whool', 'eco']
      v.forEach(e => { $(`#picotorm-text-${e}`).css("display", "none") })
      $(`#${this.dataset.target}`).css("display","block")
    })
  }

  showIconText('#picotorm-icon-handmade')
  showIconText('#picotorm-icon-whool')
  showIconText('#picotorm-icon-eco')
}

$('document').ready(main);
